import { MethodName } from './enums';
export class NeoDapi {
    constructor(provider) {
        this.provider = provider;
    }
    getProvider() {
        return this.provider.request({ method: MethodName.GetProvider });
    }
    getNetworks() {
        return this.provider.request({ method: MethodName.GetNetworks });
    }
    getAccount() {
        return this.provider.request({ method: MethodName.GetAccount });
    }
    getNep17Balances(params) {
        return this.provider.request({ method: MethodName.GetNep17Balances, params });
    }
    getBlockCount(params) {
        return this.provider.request({ method: MethodName.GetBlockCount, params });
    }
    getBlock(params) {
        return this.provider.request({ method: MethodName.GetBlock, params });
    }
    getTransaction(params) {
        return this.provider.request({ method: MethodName.GetTransaction, params });
    }
    getApplicationLog(params) {
        return this.provider.request({ method: MethodName.GetApplicationLog, params });
    }
    getStorage(params) {
        return this.provider.request({ method: MethodName.GetStorage, params });
    }
    invokeRead(params) {
        return this.provider.request({ method: MethodName.InvokeRead, params });
    }
    invokeReadMulti(params) {
        return this.provider.request({ method: MethodName.InvokeReadMulti, params });
    }
    invoke(params) {
        return this.provider.request({ method: MethodName.Invoke, params });
    }
    invokeMulti(params) {
        return this.provider.request({ method: MethodName.InvokeMulti, params });
    }
}
//# sourceMappingURL=neoDapi.js.map